<template>
	<div v-if="user.hasRole(['manager', 'admin', 'staff'])">
		<navbar
			@reload="reload"
			:data="item"
			:user="user"
			:type="'edit'"
			:isAuth="isAuth">
		</navbar>

		<div v-if="item" class="row">
			<div class="col-md-12">
				<agreements-datatable
					ref="datatable"
					@reload="reload"
					:user="user"
					:isAuth="isAuth"
					:customer="item">
				</agreements-datatable>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'

	import Navbar from './Navbar.vue'
	import AgreementsDatatable from '@/components/agreements/views/Datatable.vue'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'navbar': Navbar,
			'agreements-datatable': AgreementsDatatable,
		},
		data () {
			return {
				item: null,
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.getData()
			},
			reload() {
				this.getData()
				this.$refs.datatable.reload()
			},
			getData() {
				this.$http.get('admin/customers/' + this.$route.params.id)
				.then(response => {
					this.item = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/customers/views/Agreements.vue